import { useEffect, useRef, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetch(
          'https://c1l91zet7e.execute-api.us-east-1.amazonaws.com/prod/substack'
        ).then((res) => res.json());
        setBlogs(data.filter((post) => post.title !== 'Coming soon'));
      } catch (error) {
        console.error('Failed to fetch blog posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

return (
    <div style={{ padding: '2rem', maxWidth: '700px', margin: '0 auto' }}>
        <h1>OutfitterFinder Blog</h1>
        <p>Stay updated with the latest posts from our blog. Explore insights, updates, and stories curated just for you.</p>

        {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <CircularProgress />
            </Box>
        ) : (
            blogs.map((post, index) => <SubstackEmbed key={index} url={post.link} />)
        )}
    </div>
);
}

function SubstackEmbed({ url }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const match = url.match(/^(?<base>https:\/\/[^/]+)\/p\/(?<slug>[^?#]+)/);
    if (!match?.groups) return;

    const { base, slug } = match.groups;
    const iframeUrl = new URL(`${base}/embed/p/${slug}`);
    iframeUrl.searchParams.append('origin', window.location.origin);
    iframeUrl.searchParams.append('fullURL', window.location.href);

    const iframe = document.createElement('iframe');
    iframe.src = iframeUrl.toString();
    iframe.scrolling = 'no';
    iframe.sandbox = 'allow-scripts allow-same-origin allow-top-navigation allow-popups';
    iframe.allow =
      'clipboard-read clipboard-write allow-top-navigation allow-scripts allow-same-origin allow-popups';
    iframe.style.border = '2px solid orange';
    iframe.style.borderRadius = '16px';
    iframe.style.display = 'block';
    iframe.style.flexGrow = 1;
    iframe.style.width = '100%';
    iframe.style.maxWidth = '500px';
    iframe.height = '470px';

    const updateWidth = () => {
      const width = containerRef.current?.clientWidth || 500;
      iframe.style.width = width < 500 ? `${width}px` : '500px';
    };

    const messageListener = (event) => {
      if (event.origin === base && event.source === iframe.contentWindow) {
        if (event.data.iframeHeight) {
          iframe.height = event.data.iframeHeight;
        }
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    window.addEventListener('message', messageListener);

    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(iframe);

    return () => {
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('message', messageListener);
    };
  }, [url]);

  return (
    <div
      ref={containerRef}
      style={{
        maxWidth: '500px',
        marginTop: '20px',
        marginBottom: '20px',
        display: 'flex',
      }}
    />
  );
}
